import { getWixThemeVariableToColorMap } from '@wix/wix-site-theme-variables';
import { getRicosShadeCssVars } from '@wix/communities-blog-client-common';

const themeVariableToColorMap = getWixThemeVariableToColorMap();

export const getPostRicosShadeCssVars = (colors: Record<string, string>) => {
  const resolveColor = (value: string | undefined, fallback: string) => {
    const themeVariable = value?.match(/^var\(--([\w-]+)\)$/)?.[1];
    if (themeVariable) {
      const reference = themeVariableToColorMap[themeVariable]?.[0]?.replace('_', '-');
      return (reference && colors[reference]) || fallback;
    }
    return value || fallback;
  };

  return getRicosShadeCssVars(
    resolveColor(colors.postBackgroundColor, colors['color-1'] || '#ffffff'),
    resolveColor(colors.textParagraphColor, colors['color-5'] || '#212121'),
  );
};
